// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"5072ac51","732":"9a305367"}[chunkId] + ".chunk.js";
};